var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5v9.58a3.33 3.33 0 1 1-6.67 0V4.17a2.08 2.08 0 0 1 4.17 0v8.75c0 .45-.38.83-.83.83a.84.84 0 0 1-.84-.83V5H8.33v7.92a2.08 2.08 0 0 0 4.17 0V4.17a3.33 3.33 0 1 0-6.67 0v10.41a4.58 4.58 0 1 0 9.17 0V5h-1.25Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperClip);
export default ForwardRef;